'use client';

import { motion } from 'motion/react';
import { DynamicIcon, type IconName } from 'lucide-react/dynamic';
import { useSectionMotionVariants } from '@/components/shared/motion';

/** Lucide `DynamicIcon` expects kebab-case; normalizes legacy camelCase CMS values. */
function lucideIconNameFromCms(value: string): string {
  return value.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
}

export default function ApproachCard({
  iconName,
  title,
  description,
}: {
  iconName: string;
  title: string;
  description: string;
}) {
  const { sectionCardRevealVariants } = useSectionMotionVariants();

  return (
    <motion.div
      key={title}
      variants={sectionCardRevealVariants}
      className="relative overflow-hidden rounded-xl border bg-card dark:bg-neutral-900 p-4 sm:p-6 shadow-xs dark:border-white/10"
    >
      <div className="flex flex-col items-start gap-4 sm:flex-row sm:items-center sm:gap-6">
        <div className="flex size-9 sm:size-12 shrink-0 items-center justify-center rounded-full bg-neutral-50 border dark:bg-neutral-700 text-black dark:text-white/80 dark:border-white/10">
          <DynamicIcon
            name={lucideIconNameFromCms(iconName) as IconName}
            className="size-4 sm:size-5 shrink-0"
          />
        </div>
        <div className="min-w-0 flex-1 space-y-1">
          <h3 className="text-lg sm:text-xl text-foreground font-medium leading-tight">{title}</h3>
          <p className="text-xs sm:text-sm leading-relaxed text-muted-foreground font-light text-pretty">
            {description}
          </p>
        </div>
      </div>
    </motion.div>
  );
}
